import { Helmet } from "react-helmet-async";
import { getPage } from "../seo/pages.js";
import { buildHead } from "../seo/schema.js";

// Staging builds set VITE_SITE_ENV=staging so they can never be indexed.
const INDEXABLE = (import.meta.env.VITE_SITE_ENV || "production") === "production";

// Head tags for a page. Pass `path` to use the entry in src/seo/pages.js, and
// any overrides (title, description, image, noindex, jsonLd) for pages whose
// metadata comes from the API, such as event details.
const Seo = ({ path, ...overrides }) => {
  const page = { ...(getPage(path) || { path }), ...overrides };
  const { title, tags, jsonLd, htmlLang } = buildHead(page, { indexable: INDEXABLE });

  return (
    <Helmet htmlAttributes={{ lang: htmlLang }}>
      <title>{title}</title>
      {tags.map(([Tag, attrs]) => (
        <Tag key={`${Tag}-${attrs.name || attrs.property || attrs.rel}-${attrs.hreflang || ""}`} {...attrs} />
      ))}
      {jsonLd.map((schema, index) => (
        <script key={`ld-${index}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
